module.exports = __webpack_public_path__ + "static/media/FiltradoAzul.e8eb189b.pdf";